import React from 'react';

import AdrDriftCheckSetting from '../widgets/settings/AdrDriftCheckSetting';
import AiAgentPreferences from '../widgets/settings/AiAgentPreferences';
import DangerZone from '../widgets/settings/DangerZone';
import GitReviewerSetting from '../widgets/settings/GitReviewerSetting';
import NotificationPreferences from '../widgets/settings/NotificationPreferences';

const SectionLabel: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <div className="text-xs font-semibold opacity-50 uppercase tracking-wide px-1">{children}</div>
);

const SettingsPage: React.FC = () => (
  <div className="min-h-screen bg-base-200">
    <div className="p-4 space-y-6">
      <div className="space-y-1">
        <div className="text-2xl font-semibold">Settings</div>
        <div className="text-sm opacity-70 max-w-lg">Manage how MFlow notifies you, and your account data.</div>
      </div>

      <div className="space-y-3">
        <SectionLabel>Notifications</SectionLabel>
        <NotificationPreferences />
      </div>

      <div className="space-y-3">
        <SectionLabel>AI agents</SectionLabel>
        <AiAgentPreferences />
      </div>

      <div className="space-y-3">
        <SectionLabel>Automation</SectionLabel>
        <AdrDriftCheckSetting />
        <GitReviewerSetting />
      </div>

      <div className="space-y-3">
        <SectionLabel>Danger zone</SectionLabel>
        <DangerZone />
      </div>
    </div>
  </div>
);

export default SettingsPage;
